module.exports = __webpack_public_path__ + "static/media/How to merge multiple PDF document.50d1e868.png";